import {
  ADMIN_USER_FETCH_ALL,
  ADMIN_USER_FETCH_ALL_SUCCESS,
  ADMIN_USER_FETCH_ALL_FAIL,
  ADMIN_USER_ADD,
  ADMIN_USER_ADD_SUCCESS,
  ADMIN_USER_ADD_FAIL,
  ADMIN_USER_UPDATE,
  ADMIN_USER_UPDATE_SUCCESS,
  ADMIN_USER_UPDATE_FAIL,
  ADMIN_USER_DELETE,
  ADMIN_USER_DELETE_SUCCESS,
  ADMIN_USER_DELETE_FAIL,
  ADMIN_USER_SET_SORT,
  ADMIN_USER_FETCH,
  ADMIN_USER_MARK_FETCHING,
  ADMIN_USER_FETCH_SUCCESS,
  ADMIN_USER_FETCH_FAIL,
  ADMIN_USER_SET_PAGE,
  ADMIN_USER_SET_PAGE_SIZE
} from './constants';

export const fetchUsers = () => ({
  type: ADMIN_USER_FETCH_ALL
});
export const fetchUsersSuccess = users => ({
  type: ADMIN_USER_FETCH_ALL_SUCCESS, users
});
export const fetchUsersFail = error => ({
  type: ADMIN_USER_FETCH_ALL_FAIL, error
});
export const fetchUser = userId => ({
  type: ADMIN_USER_FETCH, userId
});
export const fetchUserSuccess = user => ({
  type: ADMIN_USER_FETCH_SUCCESS, user
});
export const fetchUserFail = (error, userId) => ({
  type: ADMIN_USER_FETCH_FAIL, error, userId
});
export const addUser = user => ({
  type: ADMIN_USER_ADD, user
});
export const addUserSucccess = user => ({
  type: ADMIN_USER_ADD_SUCCESS, user
});
export const addUserFail = error => ({
  type: ADMIN_USER_ADD_FAIL, error
});
export const updateUser = user => ({
  type: ADMIN_USER_UPDATE, user
});
export const updateUserSuccess = user => ({
  type: ADMIN_USER_UPDATE_SUCCESS, user
});
export const updateUserFail = (error, user) => ({
  type: ADMIN_USER_UPDATE_FAIL, error, user
});
export const deleteUser = user => ({
  type: ADMIN_USER_DELETE, user
});
export const deleteUserSuccess = () => ({
  type: ADMIN_USER_DELETE_SUCCESS
});
export const deleteUserFail = (error, user) => ({
  type: ADMIN_USER_DELETE_FAIL, error, user
});
export const setAdminUserSort = sort => ({
  type: ADMIN_USER_SET_SORT, sort
});
export const setUserPage = page => ({
  type: ADMIN_USER_SET_PAGE, page
});
export const setUserPageSize = size => ({
  type: ADMIN_USER_SET_PAGE_SIZE, size
});
export const markerUserFetching = userId => ({
  type: ADMIN_USER_MARK_FETCHING, userId
});
